/*@ngInject*/
const SubmissionActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadSubmissionActions = function (submissionId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.submission.Submission:' + submissionId + '&registrationIdentifier=/Submission/' + submissionId,
            cacheKey = 'submissionActions:' + submissionId;

        if (currentSubmissionModel.hasActionsRegistration('/Submission/' + submissionId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/Submission/' + submissionId, url);

                _.each(responseData.actions, function (action) {
                    action.name = _.replace(action.name, 'Create Report: ', '');
                });

                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('submissionActionsRepository', SubmissionActionsRepository);
